@if (taskSubmission) {
  <div>{{ keyedChoiceOptions[taskSubmission.choice].label }}</div>
  <ul class="py-1 ps-4 mb-0">
    @for (reason of taskSubmission.choiceReasons; track reason; let i = $index) {
      <li>
        @switch (reason) {
          @case (verificationReasons.prescriberReferral) {
            <span> Reference to the prescriber </span>
          }
          @case (verificationReasons.prescriberOfficeReferral) {
            <span>
              Reference to the prescriber’s office
            </span>
          }
          @case (verificationReasons.specialityReferral) {
            <span>
              Reference to the prescriber's specialty@if (taskSubmission.choiceSpecialityReferralSpeciality) {
              <span>:</span>
            }
            @if (taskSubmission.choiceSpecialityReferralSpeciality) {
              <div>
                {{ taskSubmission.choiceSpecialityReferralSpeciality}}
              </div>
            }
          </span>
        }
        @case (verificationReasons.other) {
          <span>
            Other@if (taskSubmission.choiceOtherReasonNote) {
            <span>:</span>
          }
          @if (taskSubmission.choiceOtherReasonNote) {
            <div class="phi">
              {{ taskSubmission.choiceOtherReasonNote }}
            </div>
          }
        </span>
      }
      @case (rejectionReasons.ignorePatient) {
        <span>
          Do not show me any further captures for patient
          <strong class="phi">{{ patient.fullName }} DOB {{ patient.dob | date: 'MM/dd/yyyy' }} </strong>.
        </span>
      }
      @case (rejectionReasons.ignorePrescriber) {
        <span>
          Do not show me any further captures from prescriber <strong>{{ provider.fullName }}</strong>.
        </span>
      }
      @case (rejectionReasons.ignorePatientPrescriber) {
        <span>
          Do not show me any further captures from prescriber <strong>{{ provider.fullName }}</strong> for patient
          <strong class="phi">{{ patient.fullName }} DOB {{ patient.dob | date: 'MM/dd/yyyy' }} </strong>.
        </span>
      }
    }
  </li>
}
</ul>
}
